import React from 'react';
import './customdropdown.scss';

export default function Customdropdown() {
    const handleItemClick = (id) => {
        
      }
  return (
    <>
      <div className="facet-filter">
        <p>Filters</p>
        <div class="nav-item dropdown">
          <button
            className="nav-link dropdown-toggle"
            id="specialityDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            eventKey="3"
          >
            
          </button>
          <ul className="dropdown-menu" aria-labelledby="specialityDropdown">
            {/* {doctorDeptlist.map((item) => (
              <li
                className="dropdown-item"
                data-id={item.id}
                onClick={(e) => {
                  e.preventDefault()
                  handleItemClick(item.id)
                }}
              >
                {item.name}
              </li>
            ))} */}
          </ul>
        </div>
      </div>
    </>
  )
}
